import { Characters, ItemName, Locale, ValueSet } from '@ps-smart-cp/ppfw-client';

const API_KEY_NAME_MAX_LEN = 54;

interface Schema {
  // `${userInputName>}/${uuid}` で構成される文字列
  id: string;
  apiKey: string;
  status: string;
}

interface Record {
  id: string;
  apiKey: string;
  status: string;
}

const attributes = {
  apiKey: Characters.preset.halfWidth({ maxLen: API_KEY_NAME_MAX_LEN, required: true }),
  status: ValueSet.new(),
};

const names = {
  apiKey: ItemName.of([Locale.ja, 'APIキー'], [Locale.en, 'API Key']),
  status: ItemName.of([Locale.ja, 'ステータス'], [Locale.en, 'Status']),
  maintenance: ItemName.of(
    [Locale.ja, 'APIキーマスタメンテナンス'],
    [Locale.en, 'API Key Master Maintenance'],
  ),
  register: ItemName.of([Locale.ja, 'APIキーマスタ登録'], [Locale.en, 'API Key Master Register']),
  change: ItemName.of([Locale.ja, 'APIキーマスタ変更'], [Locale.en, 'API Key Master Change']),
  detail: ItemName.of([Locale.ja, 'APIキー詳細'], [Locale.en, 'API Key Master Detail']),
  search: ItemName.of([Locale.ja, 'APIキー検索'], [Locale.en, 'API Key Search']),

  selectApiKeyBtn: ItemName.of([Locale.ja, 'APIキーを選択'], [Locale.en, 'select API Key']),
};

const apiKeyMst = {
  attributes,
  names,
};

interface ApiKeyMst {
  schema: Schema;
  record: Record;
}

export type { ApiKeyMst };
export { apiKeyMst };
